import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import { userActions, cocktailActions } from '../_actions';

class AdminPage extends React.Component {

    componentDidMount() {
      this.props.dispatch(userActions.getAll());
    }

    handleDeleteUser(_id) {
        return (e) => this.props.dispatch(userActions.delete(_id));
    }

  updateCocktailCounts() {
    return (e) => this.props.dispatch(cocktailActions.updateCocktailCounts());
  }
  updateFavoritesCounts() {
    return (e) => this.props.dispatch(cocktailActions.updateFavoritesCounts());
  }

    render() {
        const { user, users } = this.props;

      console.log("Users does have ingredients?  Cocktails?", users);
        return (
            <div className="col-md-6 col-md-offset-3">
                <h1>Hi {user.first_name}!</h1>
                <p>You're logged in with React!!</p>

              
                {users.loading && <em>Loading users...</em>}
                {users.error && <span className="text-danger">ERROR: {users.error}</span>}
                {user && user.access_level > 7 && users.items &&
                  <div>

                    <div>
                      <h3>{users.items.length} registered users:</h3>
                    </div>
                    <ol>
                        {users.items.map((thisUser, index) =>
                            <li value={thisUser.cabinet.length} key={thisUser._id}><span style={{position:"relative", left: "-3px"}}>{thisUser.favorites.length}</span>
                                {thisUser.first_name + ' ' + thisUser.last_name}
                                {
                                  thisUser.deleting ? <em> - Deleting...</em>
                                    : thisUser.deleteError ? <span className="text-danger"> - ERROR: {thisUser.deleteError}</span>
                                    : <span> - <a onClick={this.handleDeleteUser(thisUser._id)}>Delete</a></span>
                                }
                            </li>
                        )}
                    </ol>

                    <div>
                      <h3>Ingredients Popularity</h3>
                          <span><a onClick={this.updateCocktailCounts()}>Update Cocktail Counts</a></span>

                    </div>

                    <div>
                      <h3>Cocktail Popularity</h3>
                      <span><a onClick={this.updateFavoritesCounts()}>Update Favorites Counts</a></span>

                    </div>

                  </div>
                }

                <p>
                    <Link to="/login">Logout</Link>
                </p>
            </div>
        );
    }
}

function mapStateToProps(state) {
    const { users, authentication } = state;
    const { user } = authentication;
    return {
        user,
        users
    };
}

const connectedAdminPage = connect(mapStateToProps)(AdminPage);
export { connectedAdminPage as AdminPage };


// WEBPACK FOOTER //
// ./src/AdminPage/AdminPage.jsx